import { useEffect } from 'react';
import { useDispatch} from 'react-redux';
import { useParams } from 'react-router-dom';
import { axiosPath } from '../../../routing/helpers/router';
import * as moduleAction from '../../../store/actions/moduleAction';

export default function SurveyBase() {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();

  // > LOAD MODULE DATA //
  const loadModuleData = async () => {
    dispatch(
      moduleAction.fetch(
        axiosPath(
          "api_r_user_module_survey_getModuleData"
        ),
        "moduleData",
        {
          moduleBridgeHex,
        }
      )
    );
  }

  useEffect(() => {
    loadModuleData();
  }, []);
  // > LOAD MODULE DATA //

  return null;
}
